import Action from '../../Action'
// import './styles/ModalDeleteBuzon.css'
import { useState } from 'react';
import LoadSimple from '../../LoadSimple';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
const ModalDeleteBuzon =({languaje,handleShowPopup,mode,Buzon,auth,closDeleteBuzonModal,setRegisterIsValid,setData,setLoading,setError,server})=>{
    const [loadingM,setLoadingM]=useState(false);
    const [validaBtn, setValidaBtn] = useState(true);
    const [textAreaValue, setTextAreaValue] = useState('');
   
    const handleTextAreaChange = (event) => {
        if(event.target.value.length <4){
            setValidaBtn(true)
        }else{
            setValidaBtn(false)
        }
        
        setTextAreaValue(event.target.value);
      };
    const authorize=()=>{
        const data={
            // action: auth,
            comment: textAreaValue
        }
        setLoading(true)
        setRegisterIsValid(true)
        const fetchDataPost = async () => {

          let url=server.url+'/api/v1/cassia/cis_v2/authorizations/'
          let acction=''
          if(auth==='approve'){
              acction='requests/'+Buzon.id+'/apply'
          }
          if(auth==='reject'){
              acction='requests/'+Buzon.id+'/cancel'
          }
          if(auth==='request_info'){
              acction=''+Buzon.id+'/add_info'
          }
       try {
           const response = await fetch(url+acction, {
             method: 'POST',  
             headers: {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${localStorage.getItem('access_token')}`,
             },
             body:JSON.stringify(data)
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoading(false)
             setRegisterIsValid(false)
             // Manejo de la respuesta
             setData(data1)
             closDeleteBuzonModal()
             handleShowPopup('Completado',data1.message,'',true)
             // console.log(data1);
           } else {
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
            // Manejo de errores
            setError(error)
            console.error(error);
          }
        };

        fetchDataPost();
    }
    const statusWF={
  'request_info':'var(--yellow)',
  'approve':'var(--green)',
  'reject':'var(--red-alert)',
}
const txtWF={
  'request_info':'Agregar Información requerida',
  'approve':'Aplicar Solicitud',
  'reject':'Cancelar Solicitud',
}
 const reqField=()=>{
    return(
      <p className='reqField-gs'>
        *
      </p>
    )
  }
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs auth-modal-gs'>
                            <div className={'head-card-modal-gs' } >
                                <div className={'title-head-card-modal-gs '} style={{color:statusWF[auth]}}  >
                                   {txtWF[auth]}
                                </div>
                            </div>
                            <div className='content-card-modal-gs'>
                                <div className='cont-info-modal-delete-gs'>
                                    <div className='cont-message-modal-delete-gs' style={{height:'50%'}}>
                                    <div className='txt-user-modal-delete-buzon-gs' style={{display:'flex'}}>
                                                <div style={{color:'var(--txt-color)'}}>{Buzon.comment_history}</div>
                                            </div>
                                    
                                    </div>
                                    {(auth!='approve')?<div className='cont-user-modal-delete-gs'  style={{height:'30%'}}>
                                         <label className='lblCmtAuth' style={{display:'flex'}}>{'Comentarios'}{(textAreaValue==""|| textAreaValue.length<4)?reqField():''}</label> 
                                <label className='lblCmtAuth' style={{ left:'20%',color:'var(--txt-color)'}}>{'(minmo 3 caracteres)'}</label> 
                                
                                        
                                    <textarea id="nota" name="nota" className="CmtAuth" rows="4" cols="25" style={{resize: 'none'}} onChange={handleTextAreaChange}></textarea>
                                    </div>:''}
                                    <div className='cont-btn-modal-delete'>
                                            {
                                                (loadingM)?<LoadSimple></LoadSimple>:
                                                <>
                                                <Action  disabled={(auth=='approve')?false:validaBtn} origen={(auth)?'Green':'Red'} titulo={(auth)?capitalizeFirstLetter(lang[languaje]['aceptar']):capitalizeFirstLetter(lang[languaje]['rechazar'])}  action={authorize}></Action>
                                            <Action  disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closDeleteBuzonModal}></Action>
                                                </>
                                            }
                                    </div>
                                </div>
                            </div>
            </div>
        </div>
    )
}

export default ModalDeleteBuzon